import React, { useState, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";
import Form from "../../common_nextgen/common_components/form/Form";
import { PRICE_SCHEDULE_MODES } from "../../common_nextgen/utils/Constants";
import { useAxios } from "../../common_nextgen/axios/AxiosHelper";
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";
import { useToast } from "../../common_nextgen/hooks/ToastContext";
import FunctionKeys from "../../common_nextgen/common_components/FunctionKeys/FunctionKeys";
import {
  isAddMode,
  isEditMode,
  isReadOnlyMode,
} from "../../common_nextgen/utils/UtilFunctions";

import { formFields, screenInfo } from "./CopayScheduleFormConfig";
import { ROUTE_PATHS } from "../../common_nextgen/utils/Constants";

const CopayScheduleForm = ({ mode ,
  selectMode: initialSelectMode = false,
  lookupType: initialLookupType,
  initialSelectedCopaySchedules = [],
}) => {
  const { PATIENT_PAY_SCHEDULE_CRITERIA } = ROUTE_PATHS;
  const location = useLocation();
  const { axios_helper_no_header } = useAxios();
  const [stateVal, setStateVal] = useState(location.state || []);
  const { currentState, previousState } = useMemo(() => {
    let [currentState = {}] = [...stateVal].reverse();
    const previousState = [...stateVal];
    previousState.splice(stateVal.length - 1, 1);
    return {
      previousState,
      currentState,
    };
  }, [stateVal]);

  let {
    selectedCopaySchedules = [],
    previousScreen = PATIENT_PAY_SCHEDULE_CRITERIA,
    currentIndex: initialIndex = 0,
    paramsData,
    ps3PatientPaySchName,
    externalMode: initialExternalMode = false,
   
  } = useMemo(() => {
    const{
      selectedCopaySchedules ,
      previousScreen = PATIENT_PAY_SCHEDULE_CRITERIA,
      currentIndex,
      paramsData,
      ps3PatientPaySchName,
      externalMode,
     
    }=currentState;
    return{
      selectedCopaySchedules ,
      previousScreen ,
      currentIndex,
      paramsData,
      ps3PatientPaySchName,
      externalMode,
    }
  },[currentState]);
  const navigateToPage = useCustomNavigate();
  const [selectedOption, setSelectedOption] = useState("no");
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [currentMode, setCurrentMode] = useState(mode);
  const [initialFormData, setInitialFormData] = useState({});
  const [dataForSubmission, setDataForSubmission] = useState({});
  const [constraintErrors, setConstraintErrors] = useState([]);
  const [selectMode, setSelectMode] = useState(initialSelectMode);
  const [lookupType, setLookupType] = useState(initialLookupType);
  const [externalMode, setExternalMode] = useState(initialExternalMode);
  const [selectedPatient, setSelectedPatient] = useState(
    initialSelectedCopaySchedules
  );

  const toast = useToast();

  const handleBack = () => {
    if (externalMode) {
            const message = {
        message: "navigate-to-external-program",
        url: previousScreen,
        parameters: {
          state: [...previousState],
        },
      };
      console.log("back messages", message);
      window.parent.postMessage(message, "*");
    } else if (currentIndex < selectedCopaySchedules.length - 1) {
            setCurrentIndex(currentIndex + 1);
      setCurrentMode(mode);
    } else {
            navigateToPage(previousScreen, previousState);
    }
  };

  const getPageTitle = () => {
    const [screenTitle, screenNumber] = isAddMode(mode)
      ? screenInfo.ADD
      : screenInfo.CHANGE;
    return (
      <>
        <span className="title">{screenTitle}</span>
        <span>{"-"}</span>
        <span className="screen-number">{screenNumber}</span>
      </>
    );
  };
  const submitForm = async (dataForSubmission) => {
    let url = "";
    let verb = "";
    let screenNumber = "";

    if (isAddMode(currentMode)) {
      url = "api/cshCopayScheduleHeader";
      verb = "POST";
      screenNumber = screenInfo.ADD[1];
    } else {
      url = "api/cshCopayScheduleHeader";
      verb = "PUT";
      screenNumber = screenInfo.CHANGE[1];

      if (
        JSON.stringify(dataForSubmission) === JSON.stringify(initialFormData)
      ) {
        toast.current.show({
          severity: "info",
          summary: "",
          detail: "No Change of Information",
          life: 3000,
        });
        return;
      }
    }

    const data = { ...dataForSubmission, screenNumber };

    try {
      const { responseStatus, responseData } = await axios_helper_no_header(
        verb,
        url,
        data,
        null
      );
      toast.current.show({
        severity: "success",
        summary: "",
        detail: responseStatus.message,
        life: 3000,
      });
      setInitialFormData(responseData);
      if (isAddMode(currentMode)) {
        setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
        const [previousLastRecord = {}] = previousState.splice(
          previousState.length - 1,
          1
        );
        const { paramsData = {} } = previousLastRecord;
        const updatedParamsData = {
          ...paramsData,
          cshCopayScheduleId: responseData["cshCopayScheduleId"],
          hiddenRecordIndicator: "Active",
        };
        const updatedPreviousState = [
          ...previousState,
          { ...previousLastRecord, paramsData: updatedParamsData },
        ];
        const latestCurrentState = {
          ...currentState,
          selectedCopaySchedules: [{ ...responseData }],
          currentIndex: 0,
          previousScreen: previousScreen,
        };

        navigateToPage(ROUTE_PATHS.COPAY_SCHEDULE_EDIT, [
          ...updatedPreviousState,
          latestCurrentState,
        ]);
      } else {
        setInitialFormData(responseData);
      }
    } catch (error) {
      const { responseStatus: { displayErrorFields = null, message } = {} } =
        error.data;
      if (displayErrorFields === null) {
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      } else {
        setConstraintErrors(displayErrorFields);
      }
    }
  };

  const [keyFunc, keyName] = useMemo(() => {
    const keyFunc = {};
    const keyName = {};

    if (isAddMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
    } else if (isEditMode(currentMode)) {
            keyFunc.F12 = handleBack;
      keyName.F12 = "Back";

      keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.READ_ONLY);
      keyName.chmod = "View";

      keyFunc.F7 = () => {
                navigateToPage(ROUTE_PATHS.COPAY_SCHEDULE_STEPS, [
          ...previousState,
          { ...currentState, currentIndex, externalMode },
          {
            previousScreen: location.pathname,
            currentIndex: 0,
            selectedSchedules: [initialFormData],
          },
        ]);
      };
      keyName.F7 = "Steps";

      keyFunc.F14 = () =>
        navigateToPage(ROUTE_PATHS.COPAY_SCHEDULE_NOTE, [
          ...previousState,
          { ...currentState, currentIndex, externalMode },
          {
            selectedCopaySchedules: [initialFormData],
            currentIndex: 0,
            previousScreen: location.pathname,
          },
        ]);
      keyName.F14 = "Note";
    } else if (isReadOnlyMode(currentMode)) {
            keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
      keyName.chmod = "Edit";

      keyFunc.F7 = () => {
          navigateToPage(ROUTE_PATHS.COPAY_SCHEDULE_STEPS, [
            ...previousState,
            { ...currentState, currentIndex ,externalMode},
            {
              previousScreen: location.pathname,
              currentIndex: 0,
              selectedSchedules: [initialFormData],
            },
          ]);
      };
      keyName.F7 = "Steps";

      keyFunc.F14 = () =>
        navigateToPage(ROUTE_PATHS.COPAY_SCHEDULE_NOTE, [
          ...previousState,
          { ...currentState, currentIndex ,externalMode},
          {
            selectedCopaySchedules: [initialFormData],
            currentIndex: 0,
            previousScreen: location.pathname,
          },
        ]);
      keyName.F14 = "Note";
    }

    return [keyFunc, keyName];
  }, [currentMode, currentIndex, initialFormData]);

  useEffect(() => {
    const fetchInitialData = async () => {
      const url = isAddMode(currentMode)
        ? `api/cshCopayScheduleHeader/initialFormData/${encodeURIComponent(
            screenInfo.ADD[1]
          )}`
        : `api/cshCopayScheduleHeader/${encodeURIComponent(
            selectedCopaySchedules[currentIndex].cshCopayScheduleId
          )}`;
      const { responseData } = await axios_helper_no_header("GET", url);
      setInitialFormData(responseData);
    };

    if (isAddMode(currentMode) || selectedCopaySchedules.length) {
      fetchInitialData();
    }
  }, [mode, currentIndex,selectMode,currentState]);
  const handleMessage = (event) => {
    const { type, data } = event.data;
    console.log("iframe load", type, data);
    if (type === "initData") {
      const { selectMode, data: paramData } = data;
      setLookupType("external");
      setSelectedPatient([...paramData.selectedSchedule]);
      setSelectMode(selectMode);
    } else if (type === "set-params") {
      setStateVal(data);
      setExternalMode(true);
    }
    console.log("message", event.data);
  };

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  });

  return (
    <div className="grid container">
      <div className="col col-12">
        <FunctionKeys keyFunc={keyFunc} keyName={keyName} />
      </div>
      <div className="col col-12">
        <h1>{getPageTitle()}</h1>
      </div>
      <div className="col col-12">
        <Form
          formData={initialFormData}
          formFields={formFields}
          mode={currentMode}
          submitFormData={submitForm}
          constraintErrors={constraintErrors}
        />
      </div>
    </div>
  );
};

export default CopayScheduleForm;
